export function botHeaderActions(mode) {
  const actions = [
    { key: 'history', label: 'Chat history' },
    { key: 'new', label: 'New chat' }
  ]
  if (mode === 'expanded') actions.push({ key: 'minimize', label: 'Minimize' })
  else actions.push({ key: 'expand', label: 'Expand to full screen', hideOnMobile: true })
  actions.push({ key: 'hide', label: 'Minimize' })
  return actions
}
